<div class="mat-dialog-draggable-main-content">
  <div class="mat-dialog-draggable-header">
    <h2 mat-dialog-title mat-dialog-draggable-title>{{'enterprise_contract.image_signing.title_popup' | translate}}
      <button type="button" class="close" aria-label="Close" (click)="onNoClick()" cdkFocusInitial>
        <span aria-hidden="true">&times;</span>
      </button>
    </h2>
    <mat-divider></mat-divider>
  </div>
    <ng-container
      *ngIf="tabsCertificates.length <= 0 && userType != 5; else enterpriseHasCertificates">
      <span class="no-registered-method-note">{{'enterprise_contract.image_signing.no_registered_method' | translate}}
        <a target="_blank" href="/home-enterprise/digital-certificate">{{'enterprise_contract.image_signing.here' | translate}}</a></span>
    </ng-container>
    <ng-template #enterpriseHasCertificates>
      <div class="row">
        <div class="col-lg-6 col-md-12" style="padding-left: 15px;">
          <mat-dialog-content>
            <nz-tabset
              [nzType]="'normal'"
              [nzAnimated]="'false'"
              class="signing-tabs"
              (nzSelectedIndexChange)="onIndexChangeSignMethodType($event)">
              <nz-tab [nzTitle]="registeredTabName" [nzDisabled]="current==1">
                <ng-template
                  #registeredTabName>{{'enterprise_contract.image_signing.registered_tab.tab_name' | translate}} </ng-template>
                <div class="registered-tab-info">
              <span
                class="registered-tab-title">{{'enterprise_contract.image_signing.registered_tab.title' | translate}}</span><br/>
                <span  class="registered-tab-title-note">{{'enterprise_contract.image_signing.registered_tab.note' | translate}}</span>
                </div>
                <div class="no-registered-method-note"
                  *ngIf="tabsCertificates.length <= 0 && userType == 5;">
                  <span>{{'enterprise_contract.image_signing.registered_tab.no_registered_image1' | translate}}
                    <a target="_blank" href="/home-enterprise/digital-certificate">{{'enterprise_contract.image_signing.here' | translate}}</a> {{'enterprise_contract.image_signing.registered_tab.no_registered_image2' | translate}}</span>
                </div>
                <!--    ánh ký bình thường-->
                <nz-tabset [nzType]="'card'"
                          (nzSelectChange)="log([$event])"
                          (nzSelectedIndexChange)="onChangeType()"
                          [(nzSelectedIndex)]="selectedIndex"
                          *ngIf="tabsCertificates.length > 0">
                  <nz-tab *ngFor="let item of tabsCertificates"
                          [ngSwitch]="item.type"
                          [nzTitle]="hasCertificates"
                          (nzSelect)="onSelectSignMethodNoImage(item)">
                    <ng-template #hasCertificates>
                      <ng-container *ngSwitchCase="1">
                        {{'digital_certificate_management.rd_certificate_type.cbx_usb' | translate}}
                      </ng-container>
                      <ng-container *ngSwitchCase="2">
                        {{'digital_certificate_management.rd_certificate_type.cbx_sim_ca' | translate}}
                      </ng-container>
                      <ng-container *ngSwitchCase="4">
                        {{'digital_certificate_management.rd_certificate_type.cbx_hsm' | translate}}
                      </ng-container>
                      <ng-container *ngSwitchCase="0">
                        {{'digital_certificate_management.rd_certificate_type.cbx_server' | translate}}
                      </ng-container>
                      <ng-container *ngSwitchCase="3">
                        {{'digital_certificate_management.rd_certificate_type.cbx_otp' | translate}}
                      </ng-container>
                    </ng-template>
                  </nz-tab>
                </nz-tabset>
                <!--end     ánh ký bình thường-->

                <!--          ảnh slick và thông tin-->

                <div>
                  <div class="row" style="text-align: center;">
                    <div class="col-md-12">
                      <div>
                        <ngx-slick-carousel class="carousel slider-single" #slickModal="slick-carousel"
                                            [config]="slideConfigLarge">
                          <div ngxSlickItem *ngFor="let cert of listSlickRender" class="slide">
                            <img *ngIf="cert.imageUrl" [src]="sanitize(cert.imageUrl)" (click)="onSelectImage(cert)" alt="">
                            <img *ngIf="!cert.imageUrl" alt="" (click)="onSelectImage(cert)"
                                [src]="translate.instant('enterprise_contract.image_signing.url_st_signature')"/>
                          </div>
                        </ngx-slick-carousel>
                      </div>
                    </div>
                    <div class="col-md-12 offset-md-3 col-sm-12 offset-sm-0" *ngIf="selectedCert">
                      <div *ngIf="selectedCert.typeCertificate!= signMethod.SIGN_OTP" style="text-align: left;">
                        <h2>{{'enterprise_contract.image_signing.registered_tab.subject_info1' | translate}}</h2>
                        <div>
                          <h5
                            *ngIf="selectedCert.typeCertificate == signMethod.SIGN_SIM_CA">{{'enterprise_contract.image_signing.mobile1' | translate}}
                            : {{selectedCert.phoneNumber}}</h5>
                          <h5>{{'enterprise_contract.image_signing.subject_name' | translate}}: {{selectedCert.issuedTo}}</h5>
                          <h5>{{'enterprise_contract.image_signing.paper_number' | translate}}: {{selectedCert.taxCode}}</h5>
                          <h5>{{'enterprise_contract.image_signing.expired_date' | translate}}
                            : {{selectedCert.expireDate | dateformat }}</h5>
                        </div>
                      </div>
                      <div *ngIf="selectedCert.typeCertificate == signMethod.SIGN_OTP" style="text-align: left;">
                        <h2>{{'enterprise_contract.image_signing.registered_tab.subject_info1' | translate}}</h2>
                        <div>
                          <h5>{{'enterprise_contract.image_signing.mobile2' | translate}}: {{selectedCert.phoneNumber}}</h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!--          ảnh slick và thông tin-->
              </nz-tab>

              <!--  tab ảnh ký mới-->
              <nz-tab [nzTitle]="newTabName">
                <ng-template #newTabName>{{'enterprise_contract.image_signing.new_tab.tab_name' | translate}}</ng-template>
                <nz-steps [nzCurrent]="current" style="margin: 0.2rem;">
                  <nz-step [nzTitle]="newTabStep1">
                    <ng-template #newTabStep1>{{'enterprise_contract.image_signing.new_tab.step1' | translate}}</ng-template>
                  </nz-step>
                  <nz-step [nzTitle]="newTabStep2">
                    <ng-template #newTabStep2>{{'enterprise_contract.image_signing.new_tab.step2' | translate}}</ng-template>
                  </nz-step>
                </nz-steps>
                <!--    vẽ ảnh ký mới -->
                <div [hidden]="current == 1">
                  <nz-tabset [nzTabPosition]="'top'" [nzType]="'card'"
                  (nzSelectedIndexChange)="onChangeTabAddNewImage()">
                    <nz-tab [nzTitle]="drawSignature" (nzSelect)="onSelectDrawSign()">
                      <ng-template
                        #drawSignature>{{'enterprise_contract.image_signing.new_tab.draw_signature' | translate}}</ng-template>
                      <div class="steps-content">
                        <canvas (load)="onLoadCanvas($event)" #myCanvas id="drawCanvas" [width]="width" [height]="height"
                                style="border:1px solid"></canvas><br/>
                        <div id="bottom-toolbar">
                          <button [disabled]="disableBtnDeleteCanvas" mat-stroked-button color="gray" class="mr-3" (click)="clearCanvas()" type="button">
                            <span class="material-icons">delete_forever</span>{{'button.delete' | translate}}
                          </button>
                          <button mat-stroked-button color="primary" class="mr-3" (click)="onSaveCanvas()" type="button">
                            <span class="material-icons">done_outline</span>{{'button.yes' | translate}}
                          </button>
                        </div>
                      </div>
                    </nz-tab>
                    <nz-tab [nzTitle]="uploadImage">
                      <ng-template #uploadImage>{{'enterprise_contract.image_signing.new_tab.upload_image' | translate}}</ng-template>
                      <div style="padding-top: 1em; padding-left: 3em;">
                        <div class="row">
                          <label>{{'title.upload_image_sign' | translate}}</label>
                          <div class="clearfix nz-upload-clearfix">
                            <nz-upload
                              [nzAccept]="'image/jpeg,image/jpg,image/png'"
                              [nzPreview]="handlePreview"
                              class="avatar-uploader"
                              [nzCustomRequest]="dummyRequest"
                              nzName="avatar"
                              nzListType="picture-card"
                              [nzShowUploadList]="false"
                              [nzBeforeUpload]="beforeUpload"
                              (nzChange)="handleChange($event)">
                              <ng-container *ngIf="!avatarUrl">
                                <i class="upload-icon" nz-icon [nzType]="loading ? 'loading' : 'plus'"></i>
                                <div class="ant-upload-text">{{'form.select_upload' | translate}}</div>
                              </ng-container>
                              <img *ngIf="avatarUrl" [src]="sanitize(avatarUrl)" style="width: 100%"/>
                            </nz-upload>
                            <span class="nz-upload-guiding">{{'title.upload_image_sign_guiding1' | translate}}<br/>{{'title.upload_image_sign_guiding2' | translate}}</span>
                          </div>
                        </div>
                      </div>
                    </nz-tab>
                  </nz-tabset>
                </div>
                <!--    end vẽ ảnh ký mới -->

                <!--    chọn phương thức ký-->
                <div [hidden]="current ==0">
                  <div class="new-tab-step2-info">
                    <span
                      class="registered-tab-title">{{'enterprise_contract.image_signing.new_tab.step2_title' | translate}}</span>
                    <br/>
                  </div>
                  <form #f="ngForm" (ngSubmit)="f.form.valid && onClickConfirmButton()" appFocusFirstElement class="w-100">
                    <mat-dialog-content class="select-certificate">
                      <div class="row">
                        <div class="col-md-12 pb-3">
                          <ng-container
                            *ngIf="imageCertificates== undefined || imageCertificates.length == 0; else hasCertificates">
                            {{'digital_certificate_management.not_exist_certificate' | translate}}
                          </ng-container>
                          <ng-template #hasCertificates>
                            <mat-radio-group aria-labelledby="example-radio-group-label"
                                            class="example-radio-group border-bottom"
                                            [(ngModel)]="typeCertificate" [ngModelOptions]="{standalone: true}"
                                            *ngFor="let item of imageCertificates">
                              <mat-radio-button class="example-radio-button" [value]="item.type" [ngSwitch]="item.type"
                                                (change)="onSelectImageSignMethod(item.type)">
                                <ng-container *ngSwitchCase="1">
                                  {{'digital_certificate_management.rd_certificate_type.cbx_usb' | translate}}
                                </ng-container>
                                <ng-container *ngSwitchCase="2">
                                  {{'digital_certificate_management.rd_certificate_type.cbx_sim_ca' | translate}}
                                </ng-container>
                                <ng-container *ngSwitchCase="4">
                                  {{'digital_certificate_management.rd_certificate_type.cbx_hsm' | translate}}
                                </ng-container>
                                <ng-container *ngSwitchCase="0">
                                  {{'digital_certificate_management.rd_certificate_type.cbx_server' | translate}}
                                </ng-container>
                                <ng-container *ngSwitchCase="3">
                                  {{'digital_certificate_management.rd_certificate_type.cbx_otp' | translate}}
                                </ng-container>
                                <ng-container *ngSwitchCase="6">
                                  {{'enterprise_contract.image_signing.new_tab.no_select_method' | translate}}
                                </ng-container>
                              </mat-radio-button>
                              <div class="container" *ngIf="item.type == typeCertificate && item.type != 6">
                                <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group"
                      [(ngModel)]="selectedCert" [ngModelOptions]="{standalone: true}">
                      <!-- Not OTP -->
                      <mat-table [dataSource]="item.listCert" *ngIf="item.type != 3; else otp">
                        <!-- Chủ thể CTS column -->
                        <ng-container matColumnDef="issuedTo">
                          <mat-header-cell *matHeaderCellDef class="co-col mat-cell-non-boder-right-bottom"
                            style="max-width: 50%;">
                            {{'digital_certificate_management.issuedTo_name' | translate}}
                          </mat-header-cell>
                          <mat-cell *matCellDef="let cert" class="mat-cell-non-boder-right-bottom align-middle"
                            style="max-width: 50%" matTooltip="{{cert.issuedTo}}">
                            <mat-radio-button (change)="onChangeSubType(cert)" class="ml-2 mt-2 mat-header-cell-center" [value]="cert">
                              <span class="fix-width">{{cert.issuedTo}}</span>
                            </mat-radio-button>

                          </mat-cell>
                        </ng-container>

                        <!-- Mã số thuế column -->
                        <ng-container matColumnDef="taxCode">
                          <mat-header-cell *matHeaderCellDef class="co-col mat-cell-non-boder-right-bottom"
                            style="max-width: 30%;">
                            {{'digital_certificate_management.mst' | translate}}
                          </mat-header-cell>
                          <mat-cell *matCellDef="let cert" class="mat-cell-non-boder-right-bottom number-cell-right"
                            style="max-width: 30%;" matTooltip="{{cert.taxCode}}">
                            {{cert.taxCode}}
                          </mat-cell>
                        </ng-container>

                        <!-- Số điện thoại -->
                        <ng-container matColumnDef="phoneNumber">
                          <mat-header-cell *matHeaderCellDef class="co-col mat-cell-non-boder-right-bottom"
                            style="max-width: 30%;" [ngStyle]="{'display': typeCertificate == 2 ? null : 'none'}">
                            {{'digital_certificate_management.lbl_phone' | translate}}
                          </mat-header-cell>
                          <mat-cell *matCellDef="let cert" class="mat-cell-non-boder-right-bottom number-cell-right"
                            style="max-width: 30%;" [ngStyle]="{'display': typeCertificate == 2 ? null : 'none'}" matTooltip="{{cert.phoneNumber}}">
                            {{cert.phoneNumber}}
                          </mat-cell>
                        </ng-container>

                        <!-- Ngày hoàn thành column -->
                        <ng-container matColumnDef="expireDate">
                          <mat-header-cell *matHeaderCellDef class="co-col mat-cell-non-boder-bottom" style="max-width: 25%;">
                            {{'headertable.end_of_activate_date' | translate}}
                          </mat-header-cell>
                          <mat-cell *matCellDef="let cert" class="mat-cell-non-boder-bottom number-cell-right"
                            style="max-width: 25%;" matTooltip="{{cert.expireDate | dateformat}}">
                            {{cert.expireDate | dateformat}}
                          </mat-cell>
                        </ng-container>
                        <mat-header-row *matHeaderRowDef="columnsToDisplay;"></mat-header-row>
                        <mat-row *matRowDef="let row; columns: columnsToDisplay;"></mat-row>
                      </mat-table>

                      <!-- OTP -->
                      <ng-template #otp>
                        <h6><strong>{{'digital_certificate_management.phone_number' | translate}}</strong></h6>
                        <mat-radio-button (change)="onChangeSubType(cert)" class="example-radio-button w-100" *ngFor="let cert of item.listCert"
                          [value]="cert">
                          <span style="font-size: 16px;">{{cert.phoneNumber}}</span>
                        </mat-radio-button>
                      </ng-template>
                    </mat-radio-group>
                              </div>
                              <div class="container" *ngIf="item.type == typeCertificate && item.type === 6"
                                  style="margin: 0 0 0.5rem 0.5rem;">
                              <span class="registered-tab-title-note">{{'enterprise_contract.image_signing.new_tab.step2_note' | translate}}</span>
                              </div>
                            </mat-radio-group>
                          </ng-template>
                        </div>
                      </div>
                    </mat-dialog-content>
                  </form>
                </div>
                <!--   end chọn phương thức ký -->
              </nz-tab>
              <!-- end tab ảnh ký mới-->
            </nz-tabset>
          </mat-dialog-content>
            <mat-divider class="preview-divider"></mat-divider>
            <div class="w-100 mat-dialog-draggable-footer">
              <mat-dialog-actions align="center">
                <!--      nút huỷ-->
                <button mat-stroked-button color="primary" class="mr-3" (click)="onClickCancelButton()" type="button">
                  <mat-icon class="mr-0">cancel</mat-icon>
                  {{'button.cancel' | translate}}
                </button>
                <!--      nút quay lại-->
                <button (click)="pre()" [disabled]="!this.fileUpload" *ngIf="selectNewImageSign && current == 1"
                        mat-raised-button color="primary"><i nz-icon nzType="left"></i>{{'button.back' | translate}}
                </button>

                <!--      nút tiếp tục, chọn ảnh sau đó chọn phương thức ký-->
                <button (click)="next()" [disabled]="!this.fileUpload" *ngIf="selectNewImageSign && current == 0"
                        mat-raised-button color="primary">{{'button.next' | translate}}<i nz-icon nzType="right"></i></button>
                <!--      nút ký khi chọn hình ảnh và cert-->
                <button mat-raised-button type="submit"
                        (click)="onClickSignButton()"
                        [disabled]="disableButtonSign"
                        color="primary">
                  <mat-icon class="mr-0">gesture</mat-icon>
                  {{'button.sign' | translate}}
                </button>
              </mat-dialog-actions>
            </div>
        </div>
        <div class="col-lg-6 col-md-12">
          <!--  preview pdf-->
          <!--<div class="row" [hidden]="current == 1"> -->
          <div class="row">
            <span class="preview-title">{{'enterprise_contract.image_signing.preview' | translate}}</span>
            <div id="scrolling_div" class="overflow-auto scrolling-preview-div">
              <ngx-extended-pdf-viewer
                class="pdf-viewer"
                [src]="pdfSrc"
                [zoom]="zoomLevel"
                (textLayerRendered)="textLayerRendered($event)">
              </ngx-extended-pdf-viewer>
            </div>
          </div>
          <!--end preview pdf-->
        </div>
      </div>
    </ng-template>
</div>


